import { PenLine } from 'lucide-react'
import { cn } from '@/lib/utils'

/** Text wordmark until there is a logo. `suffix` labels a surface (e.g. "ops"). */
export function BrandMark({ suffix, className }: { suffix?: string; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2 font-semibold text-foreground', className)}>
      <span className="inline-flex size-6 items-center justify-center rounded-md bg-primary text-primary-foreground">
        <PenLine className="size-3.5" />
      </span>
      <span className="text-body-lg">PixelSign</span>
      {suffix ? (
        <span className="rounded-sm bg-accent px-1 text-caption font-medium text-muted-foreground">{suffix}</span>
      ) : null}
    </span>
  )
}
